// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1_L61","toggle":"styles_toggle__2h5gM","preview":"styles_preview__1r06R"};